var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, ViewChild } from '@angular/core';
import { ElementSettingModalBase } from '../base/element-setting-modal-base';
import { BitConditionModel } from '../shared/condition/bit/bit-condition-model';
import { RelationType } from '../shared/condition/comm/relation-type';
import { FlowDirectionType } from '../../diagram/utils/pipe/flow-direction-type';
import { ConditionItemModel } from '../shared/condition/condition-item-model';
import { ConditionType } from '../shared/condition/condition-type';
import { BitConditonLogic } from '../shared/condition/bit/bit-condition-logic';
var PipeSettingModalComponent = /** @class */ (function (_super) {
    __extends(PipeSettingModalComponent, _super);
    function PipeSettingModalComponent(injector, changeDetector, flowDirectionService) {
        var _this = _super.call(this, injector, 'pipeSettingModal') || this;
        _this.changeDetector = changeDetector;
        _this.flowDirectionService = flowDirectionService;
        return _this;
    }
    Object.defineProperty(PipeSettingModalComponent.prototype, "isFlowBlock", {
        get: function () {
            return this.isFlowBlockValue;
        },
        set: function (value) {
            this.isFlowBlockValue = value;
            if (value) {
                this.blockWidth = 6;
                this.blockLength = 12;
                this.blockMargin = 6;
                this.blockColor = '#0081ff';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PipeSettingModalComponent.prototype, "isPipeWall", {
        get: function () {
            return this.isPipeWallValue;
        },
        set: function (value) {
            this.isPipeWallValue = value;
            if (value) {
                this.pipeWallSize = 1;
                this.pipeWallColor = '#333';
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PipeSettingModalComponent.prototype, "isFlow", {
        get: function () {
            return this.isFlowValue;
        },
        set: function (value) {
            this.isFlowValue = value;
        },
        enumerable: true,
        configurable: true
    });
    PipeSettingModalComponent.prototype.init = function (editedComponent) {
        var _this = this;
        this.active = true;
        this.changeDetector.detectChanges();
        _super.prototype.init.call(this, editedComponent);
        this.configureId = editedComponent.configureId;
        var model = editedComponent.model.data;
        if (model.isFlowBlock == null) {
            model.isFlowBlock = true;
        }
        this.isFlowBlock = model.isFlowBlock;
        if (model.isPipeWall == null) {
            model.isPipeWall = true;
        }
        this.isPipeWall = model.isPipeWall;
        this.isFlow = model.isFlow;
        this.pipeDiameter = null != model.pipeDiameter ? model.pipeDiameter : 14;
        this.pipeWallSize = null != model.pipeWallSize ? model.pipeWallSize : 1;
        this.pipeWallColor = model.pipeWallColor ? model.pipeWallColor : '#333';
        this.backGroundColor = model.backGroundColor ? model.backGroundColor : '#ffffff';
        this.blockWidth = model.blockWidth ? model.blockWidth : 6;
        this.blockLength = model.blockLength ? model.blockLength : 12;
        this.blockMargin = null != model.blockMargin ? model.blockMargin : 6;
        this.blockColor = model.blockColor ? model.blockColor : '#0081ff';
        this.flowDirection = model.flowDirection ? model.flowDirection : FlowDirectionType.Positive;
        this.flowDirectionList = this.flowDirectionService.getFlowDirection();
        this.recoverData(editedComponent);
        setTimeout(function () {
            _this.displaySettingCmp.init(editedComponent);
        }, 500);
        if (this.conditionalControlCmp) {
            this.conditionalControlCmp.init(editedComponent);
        }
    };
    PipeSettingModalComponent.prototype.validate = function () {
        if (+this.pipeDiameter < 1) {
            this.message.warn(this.lc('PipeDiameter') + this.lc('MustGreaterThan', 1), this.lc('Note'));
            this.setActiveTab(0);
            return false;
        }
        if (this.isPipeWall && +this.pipeWallSize < 0) {
            this.message.warn(this.lc('PipeWallSize') + this.lc('MustGreaterThan', 0), this.lc('Note'));
            this.setActiveTab(0);
            return false;
        }
        if (this.isFlowBlock) {
            if (+this.blockWidth < 1) {
                this.message.warn(this.lc('BlockWidth') + this.lc('MustGreaterThan', 1), this.lc('Note'));
                this.setActiveTab(1);
                return false;
            }
            if (+this.blockLength < 1) {
                this.message.warn(this.lc('BlockLength') + this.lc('MustGreaterThan', 1), this.lc('Note'));
                this.setActiveTab(1);
                return false;
            }
            if (+this.blockMargin < 0) {
                this.message.warn(this.lc('BlockMargin') + this.lc('MustGreaterThan', 0), this.lc('Note'));
                this.setActiveTab(1);
                return false;
            }
        }
        return true;
    };
    PipeSettingModalComponent.prototype.save = function () {
        if (!this.validate()) {
            return;
        }
        this.saving = true;
        this.currentDiagram.startTransaction('pipe settings');
        if (this.conditionalControlCmp && !this.conditionalControlCmp.save()) {
            this.saving = false;
            this.setActiveTab(1);
            return;
        }
        if (!this.displaySettingCmp.save()) {
            this.saving = false;
            this.setActiveTab(2);
            return;
        }
        this.saveComponentProperty('isFlowBlock', this.isFlowBlock);
        this.saveComponentProperty('isPipeWall', this.isPipeWall);
        this.saveComponentProperty('isFlow', this.isFlow);
        this.saveComponentProperty('pipeDiameter', this.pipeDiameter);
        this.saveComponentProperty('pipeWallSize', this.pipeWallSize);
        this.saveComponentProperty('pipeWallColor', this.pipeWallColor);
        this.saveComponentProperty('backGroundColor', this.backGroundColor);
        this.saveComponentProperty('blockWidth', this.blockWidth);
        this.saveComponentProperty('blockLength', this.blockLength);
        this.saveComponentProperty('blockMargin', this.blockMargin);
        this.saveComponentProperty('flowDirection', this.flowDirection);
        this.saveComponentProperty('blockColor', this.blockColor);
        this.currentDiagram.commitTransaction('pipe settings');
        this.close();
    };
    PipeSettingModalComponent.prototype.recoverData = function (editedComponent) {
        var model = editedComponent.model.data;
        if (model.controlItems == null) {
            model.controlItems = new Array();
            var name = model.variableName;
            if (name) {
                var groupName = model.variableGroupName ? model.variableGroupName : '';
                var dataSourceCode = model.dataSourceCode ? model.dataSourceCode : 0;
                var condition = new ConditionItemModel(0, ConditionType.Bit, new BitConditionModel(name, groupName, BitConditonLogic.On, dataSourceCode, false, 0), RelationType.None);
                model.controlItems.push(condition);
            }
        }
    };
    PipeSettingModalComponent.prototype.setActiveTab = function (tabId) {
        this.staticTabs.tabs[tabId].active = true;
    };
    PipeSettingModalComponent.prototype.setBackGroundColor = function (color) {
        this.backGroundColor = color;
    };
    PipeSettingModalComponent.prototype.setPipeWallColor = function (color) {
        this.pipeWallColor = color;
    };
    PipeSettingModalComponent.prototype.setBlockColor = function (color) {
        this.blockColor = color;
    };
    __decorate([
        ViewChild('displaySettingCmp', { static: false })
    ], PipeSettingModalComponent.prototype, "displaySettingCmp", void 0);
    __decorate([
        ViewChild('conditionsSettingCmp', { static: false })
    ], PipeSettingModalComponent.prototype, "conditionalControlCmp", void 0);
    __decorate([
        ViewChild('staticTabs', { static: false })
    ], PipeSettingModalComponent.prototype, "staticTabs", void 0);
    PipeSettingModalComponent = __decorate([
        Component({
            selector: 'pipe-setting-modal',
            styles: ["﻿.configure.pipe { .form-label { width: 100px; } .checkbox { padding-left: 20px; margin-bottom: 0px; } .left { width: 100%; } .right { width: 100%; } .margin-top-5 { margin-top: 5px; } .pipeWallColor, .backGroundColor, .blockColor { margin-left: 4px; } .color-picker-label { float: left; margin-top: 3px; } } .inline-label{ float: left; } .color-picker{ width: 100px; } "],
            template: "<div bsModal #settingModal=\"bs-modal\" id=\"pipeSettingModal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"settingModal\" aria-hidden=\"true\" [config]=\"{backdrop: 'static'}\" (onHidden)=\"onHidden()\"> <div class=\"modal-dialog\"> <div class=\"modal-content\"> <div class=\"fe-modal-container\"> <form class=\"configure pipe\" *ngIf=\"active\" #pipeSettingForm=\"ngForm\" novalidate (ngSubmit)=\"save()\"> <div class=\"modal-header fe-modal-header\"> <h4 class=\"fe-modal-header-title\"> {{lc(\"Pipe\")}} </h4> <div class=\"fe-modal-header-close\" aria-label=\"Close\" (click)=\"close()\">×</div> </div> <div class=\"top-line\"></div> <div class=\"fe-modal-middle\"> <tabset #staticTabs class=\"tab-container tabbable-line\"> <tab heading=\"{{lc('PipeProperty')}}\" customClass=\"m-tabs__item\"> <div class=\"fe-modal-body\"> <div class=\"fe-modal-content\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"PipeDiameter\")}}({{lc(\"Px\")}}):</label> <input type=\"number\" class=\"fe-transverse-input\" name=\"pipeDiameter\" [(ngModel)]='pipeDiameter' min=\"1\" required /> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"BackGroundColor\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"backGroundColor\" (sentColor)=\"setBackGroundColor($event)\"></color-picker> </div> </div> </div> </div> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" name=\"isPipeWall\" [(ngModel)]='isPipeWall' /> <span>{{lc(\"PipeWall\")}}:</span> </label> </div> <div class=\"fe-modal-content\" [hidden]=\"!isPipeWall\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"PipeWallSize\")}}({{lc(\"Px\")}}):</label> <input type=\"number\" name=\"pipeWallSize\" class=\"fe-transverse-input\" [(ngModel)]='pipeWallSize' min=\"0\" required /> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"PipeWallColor\")}}:</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"pipeWallColor\" (sentColor)=\"setPipeWallColor($event)\"></color-picker> </div> </div> </div> </div> </div> </tab> <tab heading=\"{{lc('FlowBlockProperty')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <div class=\"fe-modal-body\"> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" name='isFlowBlock' [(ngModel)]='isFlowBlock' /> <span>{{lc(\"FlowBlock\")}}</span> </label> </div> <div class=\"fe-modal-content\" [hidden]=\"!isFlowBlock\"> <div class=\"fe-transverse-label clearfix\"> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"BlockWidth\")}}({{lc(\"Px\")}}):</label> <input type=\"number\" class=\"fe-transverse-input\" name=\"blockWidth\" [(ngModel)]='blockWidth' min=\"1\" required /> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"BlockLength\")}}({{lc(\"Px\")}}):</label> <input type=\"number\" class=\"fe-transverse-input\" name=\"blockLength\" [(ngModel)]='blockLength' min=\"1\" required/> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"BlockMargin\")}}({{lc(\"Px\")}}):</label> <input type=\"number\" class=\"fe-transverse-input\" name=\"blockMargin\" [(ngModel)]='blockMargin' min=\"0\" required/> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"FlowDirection\")}}：</label> <select class=\"fe-transverse-input\" name=\"flowDirectionSelector\" [(ngModel)]='flowDirection'> <option *ngFor=\"let flowDirection of flowDirectionList\" [ngValue]=\"flowDirection.value\"> {{flowDirection.name}} </option> </select> </div> <div class=\"fe-half-line float-left\"> <label class=\"fe-transverse-title\">{{lc(\"BlockColor\")}}：</label> <div class=\"fe-transverse-component color-picker design-color-picker\"> <color-picker [color]=\"blockColor\" (sentColor)=\"setBlockColor($event)\"></color-picker> </div> </div> </div> <div class=\"fe-option-head\"> <label> <input type=\"checkBox\" name=\"isFlow\" [(ngModel)]=\"isFlow\" /> <span>{{lc(\"StartStopControl\")}}</span> </label> </div> <div [hidden]=\"!isFlow\"> <conditional-control #conditionsSettingCmp [isControl]=\"isFlow\"></conditional-control> </div> </div> </div> </tab> <tab heading=\"{{lc('Display')}}\" customClass=\"m-tabs__item\" (selectTab)=\"tabSelected(controlSettingEventName,configureId)\"> <display-setting #displaySettingCmp [isSizeEnable]='false' [isLocationEnable]='false'></display-setting> </tab> </tabset> </div> <div class=\"fe-modal-footer\"> <div class=\"button-group\"> <button type=\"submit\" class=\"fe-btn fe-btn-default fe-btn-save\" [disabled]=\"!pipeSettingForm.form.valid\" [buttonBusy]=\"saving\" [busyText]=\"l('SavingWithThreeDot')\"> {{l(\"Save\")}} </button> <button [disabled]=\"saving\" type=\"button\" class=\"fe-btn fe-btn-default fe-btn-cancel-one\" (click)=\"close()\"> {{l(\"Cancel\")}} </button> </div> </div> </form> </div> </div> </div> </div>"
        })
    ], PipeSettingModalComponent);
    return PipeSettingModalComponent;
}(ElementSettingModalBase));
export { PipeSettingModalComponent };
